import dubbingLandingDemoData from "./dubbingLandingDemo.json";
import type { SupportedLanguage } from "../locales";

export type DubbingLandingDemoContent = {
  title: string;
  description: string;
  beforeLabel: string;
  beforeDescription: string;
  afterLabel: string;
  afterDescription: string;
};

const dubbingLandingDemoContentByLanguage = dubbingLandingDemoData as Record<
  SupportedLanguage,
  DubbingLandingDemoContent
>;

export function getDubbingLandingDemoContent(
  language: SupportedLanguage
): DubbingLandingDemoContent {
  return (
    dubbingLandingDemoContentByLanguage[language] ||
    dubbingLandingDemoContentByLanguage.en
  );
}
